/* eslint-disable func-names */
import { mensagemMinimo3Caracteres } from '@core/util/mensagemUtil';
import { validateCnpj, validateCpf } from 'app/utils/validation';
import * as Yup from 'yup';

export const useClienteValidation = () =>
  Yup.object().shape({
    codigoCliente: Yup.string().nullable(),
    observacoes: Yup.string().min(3, mensagemMinimo3Caracteres),
    optanteSimples: Yup.boolean().nullable(),
    pessoa: Yup.object().shape({
      nome: Yup.string()
        .nullable()
        .min(3, mensagemMinimo3Caracteres)
        .required('Informe o nome'),
      tipoPessoa: Yup.string().nullable(),
      inscricaoMunicipal: Yup.string().min(3, mensagemMinimo3Caracteres),
      pessoaFisica: Yup.object().shape({
        cpf: Yup.string().test('test cpf', 'CPF inválido', (value) => {
          if (value) {
            const validate = validateCpf(value);
            return validate;
          }
          return true;
        }),
        identidade: Yup.string().min(3, mensagemMinimo3Caracteres),
        dataNascimento: Yup.object().nullable(),
        identificadorEstrangeiro: Yup.string().min(3, mensagemMinimo3Caracteres),
      }),
      pessoaJuridica: Yup.object().shape({
        cnpj: Yup.string().test('test cnpj', 'CNPJ inválido', (value) => {
          if (value) {
            const validate = validateCnpj(value);
            return validate;
          }
          return true;
        }),
        razaoSocial: Yup.string().min(3, mensagemMinimo3Caracteres),
        dataFundacao: Yup.object().nullable(),
        indicadorInscricaoEstadual: Yup.string().nullable(),
        inscricaoEstadual: Yup.string().min(3, mensagemMinimo3Caracteres),
        suframa: Yup.string().nullable(),
        cnae: Yup.object().nullable(),
      }),
      contatos: Yup.array().of(
        Yup.object().shape({
          nomeReferencia: Yup.string().min(3, mensagemMinimo3Caracteres),
          email: Yup.string().email('E-mail inválido'),
          emailsAdicionais: Yup.array().of(
            Yup.object().shape({
              email: Yup.string().email('E-mail inválido'),
            })
          ),
        })
      ),
      conta: Yup.object().shape({
        descricao: Yup.string().min(3, mensagemMinimo3Caracteres),
        contaBancaria: Yup.object().shape({
          agencia: Yup.number().nullable(),
          agenciaDigito: Yup.number().nullable(),
          numeroConta: Yup.number().nullable(),
          contaDigito: Yup.number().nullable(),
          banco: Yup.object().nullable(),
        }),
        tipoConta: Yup.string()
          .nullable()
          .test('tipo.required', 'Informe o tipo da conta', function(value) {
            const {
              contaBancaria: { agencia, agenciaDigito, numeroConta, contaDigito, banco, tipoConta },
              descricao,
            } = this.parent;

            if (descricao || agencia || agenciaDigito || numeroConta || contaDigito || banco?.id) {
              return !!value || !!tipoConta;
            }

            return true;
          }),
      }),
      endereco: Yup.object().shape({
        cep: Yup.string().nullable(),
        logradouro: Yup.string().nullable(),
        numero: Yup.string().nullable(),
        complemento: Yup.string().nullable(),
        estado: Yup.string().nullable(),
        municipio: Yup.string().nullable(),
        bairro: Yup.string().min(3, mensagemMinimo3Caracteres),
        referencia: Yup.string().min(3, mensagemMinimo3Caracteres),
      }),
    }),
    contribuinteIbs: Yup.boolean()
      .nullable()
      .required('Informe se é contribuinte IBS'),
    contribuinteCbs: Yup.boolean()
      .nullable()
      .required('Informe se é contribuinte CBS'),
    tipoIndicadorOperacao: Yup.string().nullable(),
  });
